<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'PageIndex',
  methods: {
    loadPortalInfo () {
      this.$ajax({
        url: '/index/home/portal',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.$store.commit('setPortalInfo', response.data)
        }
      }, () => {})
    }
  },
  created () {
    // 兼容旧的hash模式
    const hash = this.$route.hash
    if (hash) {
      let path = hash.substring(1)
      if (path) {
        let matched = this.$router.getMatchedComponents(path)
        if (matched && matched.length) {
          this.$router.replace(path)
        }
      }
    }
  },
  mounted () {
    this.loadPortalInfo()
  }
}
</script>
